import { render } from "./OwnerListView.vue?vue&type=template&id=67fd18ce&scoped=true"
import script from "./OwnerListView.vue?vue&type=script&lang=js"
export * from "./OwnerListView.vue?vue&type=script&lang=js"

import "./OwnerListView.vue?vue&type=style&index=0&id=67fd18ce&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fd18ce"]])

export default __exports__